import React, { useEffect } from 'react';
import { Row, Col } from 'reactstrap';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import DashboardLayout from './Dashboard/Layout/DashboardLayout';
import LoadingWrapper from './Dashboard/Functions/LoadingWrapper';
import PpeStatusInfo from './Dashboard/Widget/PpeStatusInfo';
import PpeReasonInfo from './Dashboard/Widget/PpeReasonInfo';
import PpeEstablishmentInfo from './Dashboard/Widget/PpeEstablishmentInfo';
import PpeCompanyInfo from './Dashboard/Widget/PpeCompanyInfo';
import LatestAssignments from './Dashboard/Widget/LatestAssignments';
import AssignedItems from './Dashboard/Widget/AssignedItems';


const PersonalProtectiveEquipmentDashboard = () => {

  return (<DashboardLayout title={'Panel de Gestión de EPP'} hiddenTitle={true}>
    <React.Fragment>
      <Row className='m-0 p-0'>
        <Col md={2} sm={3} className='m-0 p-1'>
          <PpeStatusInfo title={'Total por Estado'} />
        </Col>
        <Col md={2} sm={3} className='m-0 p-1'>
          <PpeReasonInfo title={'Total por Motivo de Asignación'} />
        </Col>
        <Col md={8} sm={12} className='m-0 p-1'>
          <PpeEstablishmentInfo title={'Asignaciónes por Establecimiento'} minHeight={'150'} maxHeight={'400'} />
        </Col>
        <Col md={4} sm={3} className='m-0 p-1'>
          <LatestAssignments title={'Últimas 10 asignaciones'} />
        </Col>
        <Col md={3} sm={3} className='m-0 p-1'>
          <AssignedItems title={'Elementos Asignados'} />
        </Col>
        <Col md={5} sm={12} className='m-0 p-1'>
          <PpeCompanyInfo title={'Asignaciónes por Empresa'} minHeight={'150'} maxHeight={'300'} />
        </Col>
      </Row>
    </React.Fragment>
  </DashboardLayout>
  );
};

export default PersonalProtectiveEquipmentDashboard;
